<div class="page-container">
  <div class="btn-back">
    <mat-icon (click)="volver()">arrow_back</mat-icon>
    <h2>Crear Pedido</h2>
  </div>
  <!-- FORMULARIO COMPLETO -->
  <form [formGroup]="form">
    <!-- DATOS DEL CLIENTE -->
    <mat-card class="card">
      <h3 style="margin-bottom: 10px">Datos del Cliente</h3>

      <div class="grid-3">
        <!-- Nombre -->
        <mat-form-field appearance="outline">
          <mat-label>Nombre del Cliente</mat-label>
          <input matInput formControlName="customerName" />
          <mat-error *ngIf="form.get('customerName')?.hasError('required')">
            El nombre es requerido
          </mat-error>
        </mat-form-field>

        <!-- Teléfono -->
        <mat-form-field appearance="outline">
          <mat-label>Teléfono</mat-label>
          <input
            matInput
            type="text"
            formControlName="customerPhone"
            soloNumeros
          />
          <mat-error *ngIf="form.get('customerPhone')?.hasError('required')">
            El teléfono es requerido
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full">
          <mat-label>Tipo de Pedido</mat-label>
          <mat-select formControlName="tipoPedido">
            <mat-option *ngIf="tieneDelivery" value="delivery"
              >Delivery</mat-option
            >
            <mat-option value="retiro">Retiro en el local</mat-option>
          </mat-select>
          <mat-hint *ngIf="!tieneDelivery"
            >Los parámetros permiten solo retirar en local</mat-hint
          >
        </mat-form-field>

        <!-- Dirección -->
        <mat-form-field
          appearance="outline"
          class="full-3-cols"
          *ngIf="form.get('tipoPedido')?.value === 'delivery'"
        >
          <mat-label>Dirección</mat-label>
          <input matInput formControlName="deliveryAddress" />
          <mat-error *ngIf="form.get('deliveryAddress')?.hasError('required')">
            La dirección es requerida para delivery
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Tipo de entrega -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>Entrega</mat-label>
        <mat-select formControlName="tipoEntrega">
          <mat-option value="ahora">Lo antes posible</mat-option>
          <mat-option value="hora">En una hora específica</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Hora -->
      <mat-form-field
        appearance="outline"
        class="full"
        *ngIf="form.get('tipoEntrega')?.value === 'hora'"
      >
        <mat-label>Hora</mat-label>
        <input matInput type="time" formControlName="hora" />
      </mat-form-field>

      <!-- Método de pago -->
      <mat-form-field appearance="outline" class="full">
        <mat-label>Método de Pago</mat-label>
        <mat-select formControlName="paymentMethod">
          <mat-option [value]="1">Efectivo</mat-option>
          <mat-option [value]="2">Tarjeta</mat-option>
          <mat-option [value]="3">QR</mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Notas del pedido -->
      <mat-form-field
        appearance="outline"
        class="full"
        *ngIf="form.get('tipoPedido')?.value === 'delivery'"
      >
        <mat-label>Notas del Delivery</mat-label>
        <textarea matInput rows="2" formControlName="notes"></textarea>
      </mat-form-field>
    </mat-card>

    <!-- HAMBURGUESAS -->
    <mat-card class="card">
      <mat-card-title>Productos</mat-card-title>

      <div formArrayName="hamburguesas">
        <div
          class="burger-item"
          *ngFor="let h of hamburguesas.controls; let i = index"
          [formGroupName]="i"
        >
          <mat-card class="burger-card">
            <div class="row">
              <mat-form-field appearance="outline" class="type">
                <mat-label>Categoría</mat-label>
                <mat-select
                  formControlName="categoria"
                  (selectionChange)="onCategoriaChange(i)"
                >
                  <mat-option *ngFor="let c of categorias" [value]="c">
                    {{ c.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Tipo -->
              <!-- <mat-form-field appearance="outline" class="type">
                <mat-label>Tipo</mat-label>
                <mat-select formControlName="tipo">
                  <mat-option *ngFor="let t of tiposHamburguesa" [value]="t">
                    {{ t.nombre }} - ${{ t.precio }}
                  </mat-option>
                </mat-select>
              </mat-form-field> -->

              <mat-form-field appearance="outline" class="type">
                <mat-label>Producto</mat-label>
                <mat-select formControlName="producto">
                  <mat-option *ngFor="let p of productosPorItem[i]" [value]="p">
                    {{ p.name }} - ${{ p.price }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <!-- Cantidad -->
              <mat-form-field appearance="outline" class="qty">
                <mat-label>Cantidad</mat-label>
                <input matInput type="number" formControlName="cantidad" />
              </mat-form-field>

              <!-- Eliminar -->
              <button
                mat-icon-button
                color="warn"
                (click)="eliminarHamburguesa(i)"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>

            <!-- Toppings -->
            <mat-form-field
              appearance="outline"
              class="full"
              *ngIf="admiteToppings(i)"
            >
              <mat-label>Toppings</mat-label>
              <mat-select multiple formControlName="toppings">
                <mat-option *ngFor="let t of toppingsDisponibles" [value]="t">
                  {{ t.name }} (+${{ t.price }})
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field
              appearance="outline"
              class="full"
              *ngIf="admiteToppings(i)"
            >
              <mat-label>Notas del producto</mat-label>
              <textarea
                matInput
                rows="2"
                formControlName="notes"
                placeholder="Ej: sin cebolla, bien cocida, etc."
              ></textarea>
            </mat-form-field>
          </mat-card>
        </div>
      </div>

      <button
        mat-raised-button
        color="primary"
        (click)="agregarProducto()"
        type="button"
      >
        <mat-icon>add</mat-icon>
        Agregar producto
      </button>
    </mat-card>

    <!-- TOTAL -->
    <mat-card class="card total">
      <h3>Total del Pedido: ${{ form.get("total")?.value }}</h3>
      <button
        style="margin-top: 10px; width: 200px"
        mat-raised-button
        color="accent"
        (click)="guardarPedido()"
        [disabled]="form.invalid"
      >
        Guardar Pedido
      </button>
    </mat-card>

    <!-- GUARDAR -->
  </form>
</div>
